import React from 'react';
import Chart from '../../../CommonComponents/Chart';
import { chartSettings } from '../Consts';
import { IndicatorsInterface, LabelsInterface } from '../Types';
import formatValue from '../../../CommonUtils/formatValue';
import {
  Amount,
  BodyContainer,
  ChartContainer,
  Indicators,
  Label,
  LabelsContainer,
  LabelsItem,
  PortfolioDetailsContent,
  PortfolioDetailsTitle,
} from '../Styles';
import { SERIES_COLORS } from '../../../CommonComponents/OPL/charts/charts.constants';

const { ADV } = window;

const parseHtmlEntity = value => {
  const doc = new DOMParser().parseFromString(value, 'text/html');
  return doc.documentElement.textContent;
};

interface Props {
  assetValue: number;
  indicators: IndicatorsInterface[];
  portfolioName: string;
  planName: string;
  isPrint: boolean;
  labels: LabelsInterface[];
  isTruncated: boolean;
  series: any;
}

export const PortfolioDetails: React.FC<Props> = props => {
  const {
    assetValue,
    indicators,
    portfolioName,
    planName,
    isPrint,
    labels,
    isTruncated,
    series,
  } = props;

  return (
    <PortfolioDetailsContent>
      <PortfolioDetailsTitle isProposed={planName !== 'Current'}>
        {portfolioName}
        <span>{planName}</span>
      </PortfolioDetailsTitle>
      <BodyContainer>
        <ChartContainer>
          <Chart
            options={{
              ...chartSettings,
              series: [
                {
                  ...chartSettings.series[0],
                  data: series.map((item, index) => ({
                    ...item,
                    color: SERIES_COLORS[index % SERIES_COLORS.length],
                  })),
                },
              ],
              plotOptions: {
                ...chartSettings.plotOptions,
                series: {
                  ...chartSettings.plotOptions.series,
                  animation: !isPrint,
                },
              },
            }}
          />
          <Amount>{formatValue(assetValue, { type: 'currency' })}</Amount>
        </ChartContainer>
        <LabelsContainer>
          <ul>
            {labels.map((label, index) => (
              <LabelsItem key={label.index} isInactive={label.inactive} isPrimary={label.primary}>
                <i style={{ background: SERIES_COLORS[index % SERIES_COLORS.length] }} />

                <Label>{label.label}</Label>

                <div>
                  {label.value * 100 > 0 && label.value * 100 < 0.1
                    ? '< 0.1'
                    : ADV.util.number_format(label.value * 100, 1)}
                  %
                </div>
              </LabelsItem>
            ))}
            {isTruncated && <LabelsItem isTruncated={isTruncated}>Continued...</LabelsItem>}
          </ul>
        </LabelsContainer>
      </BodyContainer>
      <Indicators>
        {indicators.map(({ Label, Value }) => (
          <li key={`${Label}-${Value}`}>
            <p>{Label}</p>
            <div>{parseHtmlEntity(Value)}</div>
          </li>
        ))}
      </Indicators>
    </PortfolioDetailsContent>
  );
};
